module.exports = __webpack_public_path__ + "static/media/GZ1@2x.35ed2471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/GZ/GZ1@2x.png
// module id = 643
// module chunks = 0